import { FormattedMessage } from '@zenbusiness/application-commons-intl';
import Heading from '@zenbusiness/zui/Heading';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';

import useFlowState from '#client/hooks/flow/useFlowState';
import {
  getEntityTypeLabelFromValue,
  getJurisdictionStateLabelFromValue
} from '#client/utils/businessInfo';

function BusinessInfoSummary() {
  const { businessInfo } = useFlowState();

  const { entityType, jurisdictionState, name: businessName } = businessInfo;
  const entityTypeLabel = getEntityTypeLabelFromValue(entityType);
  const jurisdictionStateLabel = getJurisdictionStateLabelFromValue(jurisdictionState);

  return (
    <Stack spacing={0.5}>
      <Heading component="h3" size="sm" weight="medium">
        <FormattedMessage id="shopping.page.checkout.business.companyDetails" />
      </Heading>
      <Text size="xs">{businessName}</Text>
      <Text size="xs">{entityTypeLabel}</Text>
      <Text size="xs">{jurisdictionStateLabel}</Text>
    </Stack>
  );
}

export default BusinessInfoSummary;
